export const mifuncion = ()=>{
    console.log('Javascript funcionando');
}